/* Contenido -  página principal del proyecto - se víncula a diferentes página según selección del menu*/

//*react- recursos
  import { useState, useEffect } from "react";
 
//*componentes-utiles
//*clases 

//*datos
  import etiquetasSSC from "../../../datos/json/etiquetasSSC.json"

//*archivos & componentes (imagenes y elementos necesarios para la rutina)
  import ContenidoTitulo from "./Contenido.Titulo";
  import Propuesta from "./propuesta/Propuesta";
  import ResponsableDeProceso from "./responsableDeProceso/RP";
  import ResponsableDeDiseno from "./responsableDeDiseno/RD";
  import TableroDeControl from "./tableroDeControl/TC";
  import Configuracion from "./configuracion/Configuracion";

//*store's
  import menusStore from "../../../stores/menu.store";

//*interfaces
  interface propsContenido {
    tokenStore: any;
    recargaPaginaSSC: any;
    recargaPaginaSSC_Not: any;
  }

//*componente 
  export default function Contenido(props: propsContenido) {

    //*store's adicionales
      const {  paginaActivaStore, menuStore, quitaErrorPagina } =  
        menusStore((state:any) =>( {  
          paginaActivaStore: state.paginaActivaStore,
          menuStore: state.menuStore,
          quitaErrorPagina: state.quitaErrorPagina, }));
        //console.log('::::paginaActivaStore', paginaActivaStore)
    
    //*data 

    //*constantes y variables
      let eti = etiquetasSSC.Contenido.menu;
  
     //*useState
      const [swRecarga, setSwRecarga] =  useState(false);
      const [swRecargaContenido, setSwRecargaContenido] =  useState(false); //usado para remasterizar esta página
    
    //*useEffect

      useEffect(()=> {  //usado para montar
        //console.log('monto Contenido...');
        quitaErrorPagina();
      },[]);   

      useEffect(()=> {  //usado para renderizar
        //console.log('renderizando Contenido.........................');
        setSwRecargaContenido(!swRecargaContenido);
        //props.recargaPaginaSSC();
      },[swRecarga]);   

    //*funciones
    
      const recargaContenido = () => {
        //console.log('recargaContenido....');
        setSwRecarga(!swRecarga); // con esto ejecuto un useEffect, lo uso para renderizar el front 
      }

      const recargaPaginaSSC = () => { props.recargaPaginaSSC() }

      const recargaPaginaSSC_Not = () => { props.recargaPaginaSSC_Not() }

    //*vista
      return(
        <>
          <div className="container  margin-top-6r">   
{/* <p>paginaActivaStore: {paginaActivaStore}</p> */}
              <div className=""> 
                { paginaActivaStore == "RP" && <ContenidoTitulo titulo={eti[1].titulo} subtitulo={eti[1].subtitulo} nota={eti[1].nota}/> } 
                { paginaActivaStore == "P"  && <ContenidoTitulo titulo={eti[0].titulo} subtitulo={eti[0].subtitulo} nota={eti[0].nota}/> } 
                { paginaActivaStore == "RD" && <ContenidoTitulo titulo={eti[2].titulo} subtitulo={eti[2].subtitulo} nota={eti[2].nota}/> } 
                { paginaActivaStore == "TC" && <ContenidoTitulo titulo={eti[3].titulo} subtitulo={eti[3].subtitulo} nota={eti[3].nota}/> } 
                { paginaActivaStore == "C"  && <ContenidoTitulo titulo={eti[4].titulo} subtitulo={eti[4].subtitulo} nota={eti[4].nota}/> } 
              </div>
            
              <div className="background-color-white"> 
                <div className="container padding-2r">
                    { paginaActivaStore == "P"  && <Propuesta 
                                                      tokenStore={props.tokenStore} 
                                                      menuStore={menuStore} 
                                                      quitaErrorPagina={quitaErrorPagina}
                                                      recargaPaginaSSC={recargaPaginaSSC}
                                                      recargaPaginaSSC_Not={recargaPaginaSSC_Not}
                                                    /> } 
                    { paginaActivaStore == "RP" && <ResponsableDeProceso 
                                                      tokenStore={props.tokenStore} 
                                                      menuStore={menuStore} 
                                                      quitaErrorPagina={quitaErrorPagina}
                                                      recargaPaginaSSC={recargaPaginaSSC}
                                                      recargaPaginaSSC_Not={recargaPaginaSSC_Not}
                                                  /> } 
                    { paginaActivaStore == "RD" && <ResponsableDeDiseno 
                                                      tokenStore={props.tokenStore} 
                                                      menuStore={menuStore} 
                                                      quitaErrorPagina={quitaErrorPagina}
                                                      recargaPaginaSSC={recargaPaginaSSC}
                                                      recargaPaginaSSC_Not={recargaPaginaSSC_Not}
                                                  /> }
                    { paginaActivaStore == "TC" && <TableroDeControl
                                                      tokenStore={props.tokenStore} 
                                                      menuStore={menuStore} 
                                                      quitaErrorPagina={quitaErrorPagina}
                                                      recargaPaginaSSC={recargaPaginaSSC}
                                                      recargaPaginaSSC_Not={recargaPaginaSSC_Not}
                                                    /> } 
                    { paginaActivaStore == "C"  && <Configuracion
                                                      tokenStore={props.tokenStore} 
                                                      menuStore={menuStore} 
                                                      quitaErrorPagina={quitaErrorPagina}
                                                      recargaPaginaSSC={recargaPaginaSSC}
                                                      recargaPaginaSSC_Not={recargaPaginaSSC_Not}
                                                    /> } 
                </div>
              </div>

              <br/>
          </div>
        </>
      )
  }
